export enum OrganisationsTyp {
    UENB= 'UENB',
    VNB = 'VNB',
    NVNB_NICHTINTEGRIERT = 'NVNB_NICHTINTEGRIERT',
    NVNB_TEILINTEGRIERT = 'NVNB_TEILINTEGRIERT',
    NVNB_VOLLINTEGRIERT = 'NVNB_VOLLINTEGRIERT',
  }
